<template>
  <div>
    <report-panel-collapsible :report="report" :anchor="'financialreporting'" :initallyOpen="false">
      <div slot="title">Financial Reporting</div>
      <div slot="body">
        <div class="table-responsive">
          <table class="table table-striped table-condensed" id="financial-reporting-table">
            <tbody>
              <tr>
                <header-cell>
                  <template slot="heading">&nbsp; </template>
                </header-cell>
                <th
                  class="text-right"
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :class="extraClasses(index, 'accounts_date')"
                >
                  {{ isEmptyMessage(formatDate(financial.accounts_date)) }}
                </th>
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">
                    Reporting Period ({{ reportPeriod }}):
                  </template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="financial.reporting_period"
                  :extra-classes="extraClasses(index, 'reporting_period')"
                />
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">Consolidated Accounts:</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="convertYN(financial.consolidated_accounts)"
                  :extra-classes="extraClasses(index, 'consolidated_accounts')"
                />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </report-panel-collapsible>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanelCollapsible from '@/components/reports/components/ReportPanelCollapsible';
import HeaderCell from '@/components/reports/panels/financials/tablecells/HeaderCell';
import SimpleCell from '@/components/reports/panels/financials/tablecells/SimpleCell';
import financialsMixin from './FinancialsMixin';

export default {
  components: {
    ReportPanelCollapsible,
    HeaderCell,
    SimpleCell,
  },
  computed: {
    reportPeriod() {
      if (this.report.is_creditsafe_report) {
        return 'weeks';
      }
      return 'months';
    },
  },
  mixins: [financialsMixin, toolsMixin],
  props: ['report'],
};
</script>
